import { Component } from '@angular/core';

@Component({
  selector: 'app-accessibility',
  imports: [],
  templateUrl: './accessibility.component.html',
  styleUrl: './accessibility.component.css'
})
export class AccessibilityComponent {

}
